import { render, staticRenderFns } from "./LabelPrintingPageTaskOrder.vue?vue&type=template&id=dc5641a0&scoped=true&"
import script from "./LabelPrintingPageTaskOrder.vue?vue&type=script&lang=js&"
export * from "./LabelPrintingPageTaskOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5641a0",
  null
  
)

export default component.exports